import React, { useEffect, useState } from 'react'
import { postDXPreoperatorioTodos } from '../../../services/PaginaRuta'

const TablaDiagnosticosDescripcionQxPreoperatorio = ({item}) => {
    const [dataDx,setdataDx]=useState('')
    
    useEffect(()=>{
        const body = {
            varDgnEst: 'A',
            varDMCodi:item.CodDxPrPo,
            varDMNomb:''
        }
            postDXPreoperatorioTodos(body).then((res)=>{
                //setLoading(true)
                //console.log(res.data,'holaa')
                setdataDx(res.data[0])
            })
    },[])
  return (
    <tr key={item.DMCodi} className="border-b bg-white" >
      
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.CodDxPrPo}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-center">
        {dataDx.DMNomb}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.CodObsDx}
      </td>
      
    </tr>
  )
}

export default TablaDiagnosticosDescripcionQxPreoperatorio